export { default as WelcomeInfoModal } from './WelcomeInfoModal';
